import { Button, FileInfoCard, FileUpload, Text } from "@pentabd/ui";
import React from "react";

const CreateProductBatchForm = () => {
  return (
    <div className="row p-0 m-0 my-16">
      <div className="col-4 p-0 mb-20">
        <Text component="p" weight="light" size="sm">
          Download Excel File
        </Text>
      </div>
      <div className="col-6 mb-10">
        <Button fill="fill" type="primary" size="xs" className="me-5">
          Download batch upload excel
        </Button>
      </div>

      <div className="col-4 p-0 mb-10">
        <Text component="p" weight="light" size="sm">
          Upload Excel File
        </Text>
      </div>
      <div className="col-6 mb-10">
        <div className="">
          <FileUpload
            id="p-id"
            name="attachment"
            fileTypesText="SVG, JPG, PNG or GIF"
            maxSizeText="max. 800x400px"
            onChange={function noRefCheck() {}}
            onDragOver={function noRefCheck() {}}
            onDrop={function noRefCheck() {}}
          />
        </div>
        <div className="mt-10">
          <FileInfoCard
            onClickIcon={function noRefCheck() {}}
            progressBar={{
              progress: 100,
              size: "sm",
              type: "primary",
            }}
            secondaryComponent={<></>}
            subtitle="200KB"
            title="Award.pdf"
          />
        </div>
      </div>
    </div>
  );
};

export default CreateProductBatchForm;
